import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useT } from "../context/LanguageContext";

const Footer = () => {
  const t = useT();
  const groups = [
    {
      title: t("footer.product"),
      links: [
        { label: t("footer.links.voiceAi"), to: "/product/voice-ai" },
        { label: t("footer.links.phone"), to: "/product/phone" },
        { label: t("footer.links.contactCenter"), to: "/product/contact-center" },
        { label: t("footer.links.crm"), to: "/product/crm" },
        { label: t("footer.links.personalAssistant"), to: "/product/personal-assistant" },
        { label: t("footer.links.ecommerce"), to: "/product/ecommerce" },
        { label: t("footer.links.chatbot"), to: "/product/chatbot" },
        { label: t("footer.links.enterpriseAssistant"), to: "/product/enterprise-assistant" },
        { label: "Kufibot", to: "/#kufibot", anchor: true },
        { label: "Verasist Finance", to: "https://finance.verasist.ai", external: true },
        { label: "Verasist Diet", to: "https://diet.verasist.ai", external: true },
      ],
    },
    {
      title: t("footer.company"),
      links: [
        { label: t("footer.links.about"), to: "/about" },
        { label: t("references.title"), to: "/references" },
        { label: t("footer.links.careers"), to: "/careers" },
        { label: t("footer.links.press"), to: "/press" },
        { label: t("footer.links.contact"), to: "/contact" },
      ],
    },
    {
      title: t("footer.resources"),
      links: [
        { label: t("footer.links.blog"), to: "/blog" },
        { label: t("footer.links.helpCenter"), to: "/help" },
        { label: t("footer.links.scenarioTemplates"), to: "/templates" },
        { label: t("footer.links.docs"), to: "https://docs.verasist.ai", external: true },
        { label: t("footer.links.kufibotGithub"), to: "https://github.com/electronicengine/kufibot.ros2", external: true },
        { label: "Finance · GitHub", to: "https://github.com/electronicengine/verasist-finance", external: true },
        { label: "Diet · GitHub", to: "https://github.com/electronicengine/verasist-diet", external: true },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { label: t("footer.links.privacy"), to: "/privacy" },
        { label: t("footer.links.terms"), to: "/terms" },
        { label: t("footer.links.security"), to: "/security" },
        { label: t("footer.links.cookies"), to: "/cookies" },
        { label: t("footer.links.dataDeletion"), to: "/data-deletion" },
      ],
    },
  ];
  return (
    <footer className="px-6 pt-20 pb-10" style={{ borderTop: "1px solid var(--border)" }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/">
              <Logo size={28} />
            </Link>
            <p className="text-[13.5px] leading-relaxed max-w-xs mt-4" style={{ color: "var(--muted)" }}>
              {t("footer.description")}
            </p>
          </div>
          {groups.map((g) => (
            <div key={g.title}>
              <h4
                className="text-[13px] font-semibold mb-4 uppercase tracking-wider"
                style={{ color: "var(--fg)" }}
              >
                {g.title}
              </h4>
              <ul className="space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    {l.external || l.anchor ? (
                      <a
                        href={l.to}
                        {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        className="text-[13.5px] transition-colors"
                        style={{ color: "var(--muted)" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.color = "var(--brand-cyan)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.color = "var(--muted)")
                        }
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link
                        to={l.to}
                        className="text-[13.5px] transition-colors"
                        style={{ color: "var(--muted)" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.color = "var(--brand-cyan)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.color = "var(--muted)")
                        }
                      >
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="mt-16 pt-6 flex flex-col md:flex-row items-center justify-between gap-3"
          style={{ borderTop: "1px solid var(--border)" }}
        >
          <p className="text-[12.5px]" style={{ color: "var(--muted)" }}>
            © {new Date().getFullYear()} Verasist A.Ş. {t("footer.rights")}
          </p>
          <p className="text-[12.5px]" style={{ color: "var(--muted)" }}>
            {t("footer.poweredBy")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
